import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
/**
 *
 * @description Converts a random format array into a regular two-dimensional array
 * @example ['a', 'b', ['c', value]] => [['a', defaultValue], ['b', defaultValue], ['c', value]]
 */
export function normalizeFields(fields, defaultValue) {
  return fields.map(function (d) {
    if (Array.isArray(d)) {
      var _d = _slicedToArray(d, 2),
        field = _d[0],
        _d$ = _d[1],
        value = _d$ === void 0 ? defaultValue : _d$;
      return [field, value];
    }
    return [d, defaultValue];
  });
}